/**
 * @generated SignedSource<<3dc4cd13757c8097f90e9c019f62dc38>>
 * @relayHash cbefab13307a82cf7144a0c0749ceeba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 856749e0bcac9514035b3ed1c7488b61824433724d4eda1d05cbcff973b7dcce

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ReactionsCommentsQuery$variables = {
  containerId: string;
  contentId: string;
};
export type ReactionsCommentsQuery$data = {
  readonly comments: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly reactionsSummary: {
        readonly ari: string;
        readonly containerAri: string;
        readonly reactionsCount: number;
        readonly reactionsSummaryForEmoji: ReadonlyArray<{
          readonly count: number;
          readonly emojiId: string;
          readonly id: string;
          readonly reacted: boolean;
        } | null | undefined>;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type ReactionsCommentsQuery = {
  response: ReactionsCommentsQuery$data;
  variables: ReactionsCommentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "commentId",
        "variableName": "contentId"
      },
      {
        "kind": "Literal",
        "name": "contentStatus",
        "value": [
          "DRAFT",
          "CURRENT"
        ]
      }
    ],
    "concreteType": "PaginatedCommentList",
    "kind": "LinkedField",
    "name": "comments",
    "plural": false,
    "selections": [
      {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "args": [
              {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
              },
              {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
              },
              {
                "kind": "Variable",
                "name": "pageId",
                "variableName": "containerId"
              }
            ],
            "concreteType": "ReactionsSummaryResponse",
            "kind": "LinkedField",
            "name": "reactionsSummary",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "reactionsCount"
              },
              {
                "kind": "ScalarField",
                "name": "ari"
              },
              {
                "kind": "ScalarField",
                "name": "containerAri"
              },
              {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "emojiId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "count"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "reacted"
                  },
                  (v2/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ReactionsCommentsQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ReactionsCommentsQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "cbefab13307a82cf7144a0c0749ceeba",
    "id": "856749e0bcac9514035b3ed1c7488b61824433724d4eda1d05cbcff973b7dcce",
    "metadata": {},
    "name": "ReactionsCommentsQuery",
    "operationKind": "query",
    "text": "query ReactionsCommentsQuery($contentId:ID!,$containerId:ID!){comments(commentId:$contentId,contentStatus:[DRAFT,CURRENT]){nodes{id,reactionsSummary(pageId:$containerId,contentType:\"page\",childType:\"comment\"){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}}}"
  }
};
})();

(node as any).hash = "0b21ca1826000dc79e07e5aee0fcca18";

export default node;
